import React from "react";
import { Button, Loader, Pagination, Warning } from "@culturehq/components";
import client from "@culturehq/client";

import { useFetch, usePagination } from "app/hooks";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";
import ErrorMessage from "components/common/ErrorMessage";

import SurveyTable from "./SurveyTable";
import SurveyTableRow from "./SurveyTableRow";
import SurveyCompleted from "./SurveyCompleted";

const SurveysCompletedTable = ({ surveys }) => (
  <SurveyTable>
    {surveys.map(survey => (
      <SurveyTableRow key={survey.id} survey={survey}>
        <td className="actions-cell">
          <SurveyCompleted survey={survey}>
            {onTrigger => (
              <Button icon="stats-bars" inverted onClick={onTrigger}>
                <Trans>Results</Trans>
              </Button>
            )}
          </SurveyCompleted>
        </td>
      </SurveyTableRow>
    ))}
  </SurveyTable>
);

const SurveysCompleted = () => {
  const [page, onPageClick] = usePagination();
  const { error, json, loading } = useFetch(
    () => client.listProfileCompletedWidgetSurveys({ page }),
    [page]
  );

  const { surveys = [], pagination = {} } = json;

  return (
    <>
      <PageHeader title={t("Completed surveys")}>
        <Trans>Here are the surveys that have been completed and results are displayed.</Trans>
      </PageHeader>
      {error && <ErrorMessage error={error} />}
      {!error && (
        <Loader loading={loading}>
          {
            surveys.length > 0
              ? <SurveysCompletedTable surveys={surveys} />
              : <Warning><Trans>No completed surveys</Trans></Warning>
          }
          <Pagination {...pagination} onClick={onPageClick} />
        </Loader>
      )}
    </>
  );
};

export default SurveysCompleted;
